"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/AnonymousPage/Loader.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _Spinner = require('web/components/Spinner');

const Loader = () => (
  _react2.default.createElement(_Spinner.SimpleSpinner, { className: "anonymous-page--loader", __self: this, __source: {fileName: _jsxFileName, lineNumber: 5}} )
)

exports. default = Loader
